import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=639e88ba&scoped=true&"
import script from "./dictionary.vue?vue&type=script&lang=ts&"
export * from "./dictionary.vue?vue&type=script&lang=ts&"
import style0 from "./dictionary.vue?vue&type=style&index=0&id=639e88ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e88ba",
  null
  
)

export default component.exports